export default __webpack_public_path__ + "static/media/avoidentanglements.43928d47.png";